import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import * as React from "react";
import {
  AutocompleteInput,
  Button,
  Create,
  RadioButtonGroupInput,
  TextInput,
  Toolbar,
  required,
  CheckboxGroupInput,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { PnSelectionChoices, ReleaseTypeChoices, RequestTypeChoices } from "../../Constant/Source";
import { useAppDataProvider } from "../../../../dataprovider";
import { RequestOrderCreateModel } from "../../Models/RequestOrderCreateModel";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import moment from "moment";
import { RequestDeliveryInfo } from "../../Models/RequestDeliveryInfoModel";
import { RequestRemark } from "../../Models/RequestRemarkModel";
import { RemarkTypes } from "../../../../Enums/RemarkTypes";
import { useHistory } from "react-router-dom";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const RequestCreate = props => {
  const dataProvider = useAppDataProvider();
  const [loading, setLoading] = React.useState(false);
  const [createLoading, setCreateLoading] = React.useState(false);
  const [pnSelectionType, setPnSelectionType] = React.useState(true);
  const [selectedData, setSelectedData] = React.useState(null as any);
  const [selectedPn, setSelectedPn] = React.useState(null as any);
  const [selectedAirportCode, setSelectedAirportCode] = React.useState(null as any);
  const [selectedPnText, setSelectedPnText] = React.useState(null as any);
  const [formDisabled, setFormDisabled] = React.useState(false as boolean);
  const [open, setOpen] = React.useState(false);

  const history = useHistory();
  const notify = useNotify();

  const classes = useStyles();

  const _today: Date = new Date();
  const _zeroValue: number = 0;

  const CreateOrderButtonClick = async e => {
    CreateOrder(e);
    setCreateLoading(true);
  };

  const CreateOrder = async e => {
    let requestOrderCreateModel: RequestOrderCreateModel = new RequestOrderCreateModel();
    requestOrderCreateModel.Access = selectedPn?.isAccess;
    requestOrderCreateModel.AircraftId = selectedData?.acMaster?.id;
    requestOrderCreateModel.AirportCode = e.airportCode;
    requestOrderCreateModel.Chapter = Number(e.ataChapter);
    requestOrderCreateModel.ComponentDescription = e.pnDescription;
    requestOrderCreateModel.ContractId = selectedData.contract.id;
    requestOrderCreateModel.CustomerPo = e.customerPo;
    requestOrderCreateModel.CustomerPoLine = e.customerPoLine;
    requestOrderCreateModel.CustomerRequestComponent = e.pnSelection === false ? e.pnText : selectedPn.pn;
    requestOrderCreateModel.PreDefinedComponentId = selectedPn?.id ?? 0;
    requestOrderCreateModel.ReleaseType = e.releaseType?.toString?.();
    requestOrderCreateModel.Repair = e.requestType === 2 ? true : false;
    requestOrderCreateModel.RequestStatus = RequestStatus.Created;
    requestOrderCreateModel.RequestType = e.requestType;
    requestOrderCreateModel.RepairTat = e.repairTat;
    requestOrderCreateModel.RequestedDeliveryDate =
      e.repairTat != null ? moment.utc(_today, "DD-MM-YYYY").add(e.repairTat, "days").toDate() : _today;
    requestOrderCreateModel.isDefined = e.pnSelection;
    requestOrderCreateModel.AcRegistration = selectedData?.acMaster?.acReg;

    requestOrderCreateModel.RequestDeliveryInfo = new RequestDeliveryInfo();
    requestOrderCreateModel.RequestDeliveryInfo.RequestId = _zeroValue;
    requestOrderCreateModel.RequestDeliveryInfo.AttentionName = e.attentionName;
    requestOrderCreateModel.RequestDeliveryInfo.AttentionPhone = e.attentionPhone;
    requestOrderCreateModel.RequestDeliveryInfo.ConsigneeAddress = e.consigneeAddress;
    requestOrderCreateModel.RequestDeliveryInfo.ConsigneeName = e.consigneeName;
    requestOrderCreateModel.RequestDeliveryInfo.Email = e.email;
    requestOrderCreateModel.RequestDeliveryInfo.ShippingAddress = e.shippingAddress;

    requestOrderCreateModel.RequestRemark = new RequestRemark();
    requestOrderCreateModel.RequestRemark.RequestId = _zeroValue;
    requestOrderCreateModel.RequestRemark.Remark = e.customerRemark;
    requestOrderCreateModel.RequestRemark.RemarkType = RemarkTypes.CustomerFirstRemark;
    requestOrderCreateModel.RequestRemark.RemarkTypeCode = RemarkTypes[RemarkTypes.CustomerFirstRemark];
    requestOrderCreateModel.RequestRemark.StatusCode = RequestStatus.Created;
    requestOrderCreateModel.RequestRemark.isCustomer = true;

    dataProvider
      .postRequestOrder(requestOrderCreateModel)
      .then(result => {
        let requestOrder = result.data;
        notify(`Record created`, "success", false, true);
        history.push("/requestorders/" + requestOrder.id);
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setCreateLoading(false);
      });
  };

  //#region Events
  const pnChangeEvent = e => {
    let selectedPnId = e;
    let selectedPn = selectedData?.pnList.filter(pn => pn.id === selectedPnId)[0];
    setSelectedPn(selectedPn);
  };

  const pnTextBlurEvent = e => {
    let textValue = e?.target?.value;
    if (textValue === null || textValue === undefined) return;
    setSelectedPnText(e?.target?.value);
  };

  const airportCodeChangeEvent = e => {
    let airportCode = e;
    let selectedAirportCode = selectedData?.addressList.filter(pn => pn.airportCode === airportCode)[0];
    setSelectedAirportCode(selectedAirportCode);
  };

  const pnSelectionTypeChangeEvent = form => value => {
    setSelectedPn(null);
    setPnSelectionType(value);
  };
  //#endregion

  //#region useEffects
  React.useEffect(() => {
    setSelectedData(props.selectedData);
  }, [props]);

  React.useEffect(() => {
    GetPnMaster();
  }, [selectedPnText]);

  React.useEffect(() => {
    setOpen(formDisabled);
  }, [formDisabled]);
  //#endregion

  //#region requests
  const GetPnMaster = async () => {
    setLoading(true);

    if (selectedPnText !== null && selectedPnText !== undefined) {
      dataProvider
        .getPnMasterByPn(selectedPnText)
        .then((response: any) => {
          if (response?.data?.id === null) {
            clear();
            return;
          }
          let selectedPn = { ataChapter: response.data.chapter, description: response.data.pnDescription };
          setSelectedPn(selectedPn);
          setLoading(false);
        })
        .catch(error => {
          clear();
        });
    }

    const clear = () => {
      setSelectedPn(null);
      setLoading(false);
    };
  };
  //#endregion

  return (
    <Form
      onSubmit={CreateOrderButtonClick}
      render={({ handleSubmit, form, values }) => {
        return (
          <form>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Create {...props}>
                    <>
                      <Separator />
                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Contract Info" />
                      </Grid>
                      <Grid {...gridContainerProps}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="contractName"
                            initialValue={selectedData?.contract?.contractName}
                            validate={required()}
                            fullWidth
                            variant="outlined"
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                          <RadioButtonGroupInput
                            source="requestType"
                            label="Request Type"
                            fullWidth
                            defaultValue={selectedData?.requestType}
                            choices={RequestTypeChoices}
                            validate={required()}
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                      </Grid>
                      <Separator />

                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Order Info" />
                      </Grid>
                      <Grid {...gridContainerProps} alignItems={"flex-start"}>
                        <Grid item xs={12} sm={5}>
                          <RadioButtonGroupInput
                            source="pnSelection"
                            label="PN Selection"
                            initialValue={true}
                            fullWidth
                            choices={PnSelectionChoices}
                            onChange={pnSelectionTypeChangeEvent(form)}
                            validate={required()}
                            variant="outlined"
                            disabled={formDisabled}
                          />
                          {pnSelectionType === true ? (
                            <AutocompleteInput
                              source="pn"
                              optionText="pn"
                              optionValue="id"
                              choices={selectedData?.pnList}
                              resettable
                              clearAlwaysVisible={true}
                              onChange={pnChangeEvent}
                              validate={required()}
                              variant="outlined"
                              fullWidth
                              disabled={formDisabled}
                            />
                          ) : (
                            <TextInput
                              source="pnText"
                              label="Part Number"
                              fullWidth
                              resettable
                              variant="outlined"
                              onBlur={pnTextBlurEvent}
                              validate={required()}
                              disabled={formDisabled}
                            />
                          )}
                          <TextInput
                            source="pnDescription"
                            label="Component Description"
                            initialValue={selectedPn?.description ?? ""}
                            fullWidth
                            disabled={selectedPn !== null || formDisabled}
                            variant="outlined"
                            validate={required()}
                          />
                          <TextInput
                            source="repairTat"
                            label="RepairTat"
                            initialValue={selectedPn?.repairTat ?? ""}
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            disabled={pnSelectionType}
                          />
                        </Grid>

                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="ataChapter"
                            label="Ata Chapter"
                            initialValue={selectedPn?.ataChapter ?? ""}
                            fullWidth
                            disabled={selectedPn !== null || formDisabled}
                            variant="outlined"
                          />
                          <CheckboxGroupInput
                            source="releaseType"
                            choices={ReleaseTypeChoices()}
                            validate={required()}
                            disabled={formDisabled}
                          />
                          <AutocompleteInput
                            source="airportCode"
                            optionText="id"
                            optionValue="id"
                            choices={selectedData?.airportCodeList}
                            onChange={airportCodeChangeEvent}
                            suggestionLimit={10}
                            filterToQuery={searchText => ({ id__contains: searchText })}
                            variant="outlined"
                            fullWidth
                            validate={required()}
                            disabled={formDisabled}
                          />
                          <Grid container spacing={2}>
                            <Grid item xs={8} sm={9}>
                              <TextInput
                                fullWidth
                                source="customerPo"
                                label="Customer PO/RO"
                                variant="outlined"
                                validate={required()}
                                disabled={formDisabled}
                              />
                            </Grid>

                            <Grid item xs={4} sm={3}>
                              <TextInput
                                defaultValue={"1"}
                                fullWidth
                                source="customerPoLine"
                                label="Line"
                                variant="outlined"
                                validate={required()}
                                disabled={formDisabled}
                              />
                            </Grid>
                          </Grid>
                          <TextInput
                            source="customerRemark"
                            label="Remarks of Customer"
                            multiline
                            resettable
                            fullWidth
                            rows={3}
                            variant="outlined"
                            FormHelperTextProps={{
                              style: { display: "block" },
                            }}
                            helperText="If any, remarks about the order itself should be explained such as ‘Rejection order due to corrosion’"
                          />
                        </Grid>
                      </Grid>
                      <Separator />

                      <Grid {...gridContainerProps}>
                        <SectionTitle label="Delivery To" />
                      </Grid>

                      <Grid {...gridContainerProps} alignItems={"flex-start"}>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="attentionName"
                            label="Attention Name"
                            initialValue={selectedAirportCode?.attentionName}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="attentionPhone"
                            label="Attention Phone"
                            initialValue={selectedAirportCode?.attentionPhone}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="email"
                            label="E-Mail"
                            initialValue={selectedAirportCode?.email}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="shippingAddress"
                            label="Shipping Address"
                            initialValue={selectedAirportCode?.shippingAddress}
                            multiline
                            resettable
                            fullWidth
                            rows={3}
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextInput
                            source="consigneeName"
                            label="Company/Consignee Name"
                            initialValue={selectedAirportCode?.consigneeName}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                          <TextInput
                            source="consigneeAddress"
                            label="Company/Consignee Address"
                            initialValue={selectedAirportCode?.consigneeAddress}
                            fullWidth
                            resettable
                            variant="outlined"
                            disabled={formDisabled}
                            validate={required()}
                          />
                        </Grid>
                      </Grid>
                      <Separator />
                      <Toolbar {...props} placeholder="" classes={classes}>
                        <Button
                          label={createLoading ? "Order is creating!" : "Create Order"}
                          disabled={createLoading || formDisabled}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {createLoading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      </Toolbar>
                    </>
                  </Create>
                </Grid>
              </Grid>
            </>
          </form>
        );
      }}
    />
  );
};

const RbhRequestOrderCreate = props => {
  return <RequestCreate resource="requestorder" basePath="requestorder" selectedData={props.selectedData} />;
};

export default RbhRequestOrderCreate;
